import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52a458af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-part" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"header-media-group\" data-v-52a458af><button class=\"header-user\" data-v-52a458af><img src=\"/frontend/images/user.png\" alt=\"user\" data-v-52a458af></button><a href=\"/\" data-v-52a458af><img src=\"/frontend/images/logoempresa.jpg\" alt=\"logo\" data-v-52a458af></a><button class=\"header-src\" data-v-52a458af><i class=\"fas fa-search\" data-v-52a458af></i></button></div><a href=\"/\" class=\"header-logo\" data-v-52a458af><img src=\"/frontend/images/logoempresa.jpg\" alt=\"logo\" data-v-52a458af></a>", 2)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/frontend/images/user.png",
  alt: "user"
}, null, -1))
const _hoisted_7 = { class: "header-form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1))
const _hoisted_9 = { class: "header-widget-group" }
const _hoisted_10 = {
  key: 0,
  href: "#",
  class: "header-widget",
  title: "Configuraciones"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-cog" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "header-widget header-cart",
  title: "Cartlist"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shopping-basket" }, null, -1))
const _hoisted_17 = {
  key: 0,
  style: {"margin-left":"22%","margin-right":"20%","margin-top":"-10px"}
}
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Buscar cliente", -1))
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Código", -1))
const _hoisted_25 = { class: "blog-widget-form" }
const _hoisted_26 = { class: "modal-table" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Seleccionar"),
    /*#__PURE__*/_createElementVNode("th", null, "Código"),
    /*#__PURE__*/_createElementVNode("th", null, "Razón Social"),
    /*#__PURE__*/_createElementVNode("th", null, "RNC")
  ])
], -1))
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToPag && _ctx.navigateToPag(...args))),
          class: "header-widget",
          title: "My Account"
        }, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.UserLogued?.Nombre ?? 'Iniciar Session'), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.textFilter) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setglobalFilter())),
            placeholder: "Buscar aqui..."
          }, null, 544), [
            [_vModelText, _ctx.textFilter]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, { to: 'setting' }, {
            default: _withCtx(() => [
              (_ctx.UserLogued && _ctx.UserLogued?.Tipo_usuario=='administrador')
                ? (_openBlock(), _createElementBlock("a", _hoisted_10, _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.UserLogued?.Nombre && _ctx.UserLogued?.Tipo_usuario=='administrador' &&  _ctx.UserLogued?.puedeSeleccionarEmpresa)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = true)),
                class: "header-widget",
                title: "buscar un Cliente"
              }, _hoisted_14))
            : _createCommentVNode("", true),
          (!_ctx.isChecout())
            ? (_openBlock(), _createElementBlock("button", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("sup", null, _toDisplayString(_ctx.cantidadItem), 1),
                _createElementVNode("span", null, [
                  _createTextVNode("Carrito "),
                  _createElementVNode("small", null, "$" + _toDisplayString(_ctx.valorTotal.toFixed(2)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.UserLogued?.Nombre && _ctx.UserLogued?.Empresas[0]?.ClienteData )
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              value: _ctx.UserLogued?.Empresas[0]?.ClienteData?.RazonSoc,
              name: "nombreCliente",
              id: "nombreCliente"
            }, null, 8, _hoisted_18)
          ]))
        : _createCommentVNode("", true),
      _hoisted_19
    ]),
    _createVNode(_component_Modal, { showModal: _ctx.showModal }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "X"),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Buscar...",
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchTerm) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.searchTerm]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
                  class: "icofont-search-1"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.selectClient(client)), ["prevent"])
                  }, "Seleccionar", 8, _hoisted_28)
                ]),
                _createElementVNode("td", null, _toDisplayString(client.Codclte), 1),
                _createElementVNode("td", null, _toDisplayString(client.RazonSoc), 1),
                _createElementVNode("td", null, _toDisplayString(client.Rnc), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["showModal"])
  ]))
}